import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { NgxSpinnerService } from 'ngx-spinner';
import { InformacionPacienteModel } from '../models/informacion-paciente.model';
import {
	Client,
	FormularioExtendedDto,
	RespuestaExtendedDto,
	RespuestaFlatDto,
	RespuestaPreguntaDto,
	SeguimientoRespuestaExtendedDto
} from '../services/client';
import { errorMessages } from '../../../../src/assets/constants.json';

enum SubmissionStatus {
	NotSubmitted = 1,
	SubmittedSuccessfully,
	SubmissionFailed
}

@Component({
	selector: 'app-formulario-generic',
	templateUrl: './formulario-generic.component.html'
})
export class FormularioGenericComponent implements OnInit {

	@Input() casoResuleto = 'No';
	@Input() readonly = false;
	@Input() disabled = false;
	@Input() formulario: FormularioExtendedDto = new FormularioExtendedDto();
	@Input() respuesta: RespuestaExtendedDto = new RespuestaExtendedDto();
	@Input() informacionPaciente: InformacionPacienteModel = new InformacionPacienteModel();

	@Input() form: FormGroup = new FormGroup({});

	SubmissionStatus = SubmissionStatus;
	submissionStatus: SubmissionStatus = SubmissionStatus.NotSubmitted;

	submitSuccessful = false;
	establecimientoIdParam = '';
	selectedEstablecimiento = null;
	informacionPacienteCompleta = false;

	constructor(
		public router: Router,
		public route: ActivatedRoute,
		public client: Client,
		private spinner: NgxSpinnerService,
		private alertService: AlertService
	) {
	}

	ngOnInit() {
		// Get the query params
		this.route.paramMap
			.subscribe(params => {
				this.establecimientoIdParam = params.get('establecimientoId') || '';
			});
	}

	fetchSeguimientos($event) {
		const seguimiento = new SeguimientoRespuestaExtendedDto($event);
		seguimiento.id = 1;
		this.respuesta.seguimientoRespuesta.push(seguimiento);
	}

	selectEstablecimiento($event) {
		this.selectedEstablecimiento = $event;
	}

	textChanged($event) {
		this.selectedEstablecimiento = null;
	}

	volver() {
		return this.router.navigate(['public/formulario', + this.formulario.id]);
	}

	volverHome() {
		return this.router.navigate(['public']);
	}

	updateRespuesta(informacionPaciente: InformacionPacienteModel) {
		this.informacionPaciente = informacionPaciente;
		this.informacionPacienteCompleta = true;
		for (const property in this.informacionPaciente) {
			if (this.informacionPaciente.hasOwnProperty(property) &&
				this.informacionPaciente[property].toString().trim().length === 0) {
				this.informacionPacienteCompleta = false;
				break;
			}
		}
	}


	onSubmit() {
		const formularioMap = {};
		for (const pregunta in this.formulario.preguntas) {
			if (this.formulario.preguntas.hasOwnProperty(pregunta)) {
				formularioMap[this.formulario.preguntas[pregunta].id] = this.formulario.preguntas[pregunta];
			}
		}
		const respuestas = new RespuestaFlatDto();
		if (!this.formulario.requiereDatosEncuestado) {
			respuestas.init({
				'id': 0,
				'establecimientoId': this.selectedEstablecimiento.id,
				'formularioId': this.formulario.id,
				'respuestasPreguntas': []
			});
		} else {
			respuestas.init({
				'id': 0,
				'establecimientoId': this.selectedEstablecimiento.id,
				'formularioId': this.formulario.id,
				'tipoDocumentoIdentidad': 1,
				'documentoIdentidad': this.informacionPaciente.documentoIdentidad,
				'nombre': this.informacionPaciente.nombre,
				'apellido': this.informacionPaciente.apellido,
				'correoElectronico': this.informacionPaciente.correoElectronico,
				'telefono': this.informacionPaciente.telefono,
				'sexo': this.informacionPaciente.sexo,  // Optional
				'fechaNacimiento': this.informacionPaciente.fechaNacimiento, // Optional
				'respuestasPreguntas': []
			});
		}
		const valoresRespuestas = this.form.value;
		let respuestasPreguntas: RespuestaPreguntaDto;
		for (const respuesta of Object.keys(valoresRespuestas)) {
			switch (formularioMap[parseInt(respuesta.split('_')[1], 10)].tipoPregunta) {
				case 1:
				case 2:
				case 5:
				case 8:
				case 9:
					respuestasPreguntas = new RespuestaPreguntaDto({
						'id': 0,
						'preguntaId': parseInt(respuesta.split('_')[1], 10),
						'opciones': [parseInt(valoresRespuestas[respuesta], 10)]
					});

					break;

				default:
					respuestasPreguntas = new RespuestaPreguntaDto({
						'id': 0,
						'preguntaId': parseInt(respuesta.split('_')[1], 10),
						'contestacion': valoresRespuestas[respuesta]
					});
			}
			respuestas.respuestasPreguntas.push(respuestasPreguntas);
		}
		this.spinner.show();
		this.client.respuestas_PostRespuesta(respuestas)
			.finally(() => this.spinner.hide())
			.subscribe(() => {
				this.submissionStatus = SubmissionStatus.SubmittedSuccessfully;
			}, (error) => {
				this.submissionStatus = SubmissionStatus.SubmissionFailed;
				const errorMessage = error.status === 0 ?
					errorMessages.connectionError : !!error.title ? error.title : errorMessages.genericError;
				this.alertService.danger(errorMessage);
			});
	}
}
